import * as React from 'react';
import { Box, Stack, Typography, Tooltip, useMediaQuery } from '@mui/material';
import './Home.css';
const jailhat = "https://i.imgur.com/9wpOvpB.png"
const hat = 'https://i.imgur.com/d0w42SN.png'
const jail = "https://i.imgur.com/l5gnN9H.png"

function Home() {
    const mobile = useMediaQuery('(max-width:1000px)');

    const [isDropped, setIsDropped] = React.useState(false);

    const handleDragStart = (e) => {
        e.dataTransfer.setData('text/plain', 'dragging');
    };

    const handleDragOver = (e) => {
        e.preventDefault(); // Necessary to allow dropping
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDropped(true); // Update state to reflect the drop
    };


    return (
        <Stack alignItems="center" spacing={1} p={2}>
            <img src={jailhat} alt={"jail hat"} width="30%" height="auto"/>
            <Typography fontSize="3vw">Tired of getting rugged by shitty hat memes?</Typography>
            <Typography fontSize="3vw">Well we found the culprit, and now it's time to toss his ass in jail!</Typography>
            <Box>
            <div className="image-container">
                <Tooltip title="drag to jail!" placement='top'>
                    <img
                    src={hat}
                    alt="Draggable"
                    draggable="true"
                    onDragStart={handleDragStart}
                    height={mobile ? "70px" : "300px"}
                    width="auto"
                    style={{ opacity: isDropped ? 0 : 1, cursor: "pointer" }} // Hide the image when dropped
                    />
                </Tooltip>
                <div
                className="drop-area"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                style={{
                    position: 'relative',
                    width: '10vw', // Set appropriate size
                    height: '150px'
                }}
                >
                {isDropped && (
                    <img
                    src={hat}
                    alt="Dropped"
                    height={mobile ? "70px" : "300px"}
                    width="auto"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0
                    }}
                    />
                )}
                <img src={jail} alt="Jail" height={mobile ? "100px" : "300px"} width="auto" />
                </div>
            </div>
            </Box>
        </Stack>
    );
}

export default Home;